import styled from 'styled-components';
import { Icon } from '../ui';

export const Container = styled.div`
  padding-top: 1rem;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
`;

export const LegendIcon = styled(Icon)`
  width: 21px;
  height: 18px;
`;
